import { Reveal, Stagger, StaggerItem } from "../components/Motion";
import { ShieldCheck, Download } from "lucide-react";

export default function License() {
  return (
    <div data-testid="page-license">
      <section className="pt-32 md:pt-40 pb-16">
        <div className="container-luxe">
          <Reveal>
            <div className="overline mb-6">Ліцензія МОЗ</div>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="font-serif text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight max-w-4xl">
              Юридична прозорість
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-warmGray text-lg max-w-2xl leading-relaxed">
              Усі медичні маніпуляції здійснюються виключно в ліцензованих кабінетах
              із дозволами МОЗ України та сертифікованими препаратами.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24">
        <div className="container-luxe grid md:grid-cols-2 gap-8 lg:gap-12 items-start">
          <Reveal>
            <div className="aspect-[4/5] rounded-3xl bg-sand border border-line flex flex-col items-center justify-center p-10 text-center">
              <ShieldCheck size={56} strokeWidth={1} className="text-ink" />
              <div className="overline mt-6 text-warmGray">Документ</div>
              <h3 className="font-serif text-2xl md:text-3xl mt-2 leading-tight">
                Ліцензія МОЗ України
              </h3>
              <p className="text-warmGray text-sm mt-4 max-w-xs">
                Превʼю документа. Повний скан буде надано на запит або під час візиту.
              </p>
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                data-testid="license-request-btn"
                className="mt-8 inline-flex items-center gap-2 rounded-full bg-ink text-bone px-6 py-3 text-[11px] tracking-[0.28em] uppercase hover:bg-black transition"
              >
                <Download size={14} strokeWidth={1.5} /> Запитати документ
              </a>
            </div>
          </Reveal>

          <div className="space-y-6">
            <Reveal>
              <h2 className="font-serif text-3xl md:text-4xl tracking-tight">
                Що це означає для Вас
              </h2>
            </Reveal>
            <Stagger className="space-y-3">
              {[
                "Кабінет внесено до реєстру МОЗ України як заклад охорони здоровʼя",
                "Усі препарати — оригінальні, з повним пакетом документів",
                "Стерилізація та утилізація медичних матеріалів за протоколом",
                "Лікарська відповідальність та страхування",
                "Прозора звітність та документація кожної процедури",
              ].map((item) => (
                <StaggerItem key={item}>
                  <div className="flex items-start gap-4 p-5 rounded-2xl border border-line bg-bone">
                    <ShieldCheck size={18} strokeWidth={1.3} className="mt-0.5 shrink-0 text-warmGray" />
                    <div className="text-sm md:text-base">{item}</div>
                  </div>
                </StaggerItem>
              ))}
            </Stagger>
          </div>
        </div>
      </section>
    </div>
  );
}
